import { Flex, Space, Text, Textarea } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { INVOICE_FOOTER_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceFooterCharacterLimit'

import { useDebouncedCallback } from '../../../../../../../../../../hooks/useDebouncedCallback'
import { useInvoiceEditorForm } from '../../../../../../contexts/invoiceEditorFormContext'
import { useIsInvoiceEditorElementRestricted } from '../../../../../../hooks/useIsInvoiceEditorElementRestricted'

export const InvoiceFooterNote = () => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const isDisabled = useIsInvoiceEditorElementRestricted('footerNote', 'disabled')

  const { FormItem, watch } = invoiceEditorForm

  const footerNote = watch('footerNote')

  const handleDebouncedTextareaChange = useDebouncedCallback((value: string) =>
    trackInvoiceEditor('Form - Footer Note typed', {
      messageLength: value.length,
    }),
  )

  return (
    <FormItem
      name="footerNote"
      label={
        <Flex flexDirection="column">
          <Text variant="h4">{t('external_invoices.editor.form.field.invoice_footer_note.header')}</Text>
          <Space />
          <Flex justifyContent="space-between">
            <Text colorVariant="secondary">{t('external_invoices.editor.form.field.invoice_footer_note.label')}</Text>
            <Text colorVariant="secondary">{`${footerNote.length}/${INVOICE_FOOTER_CHARACTER_LIMIT}`}</Text>
          </Flex>
        </Flex>
      }
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <Textarea
            {...props}
            disabled={isDisabled}
            expandOnType
            maxHeight={160}
            maxLength={INVOICE_FOOTER_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedTextareaChange(event.target.value)
            }}
            rows={1}
            placeholder={t('external_invoices.editor.form.field.invoice_footer_note.placeholder')}
            resizable={false}
            value={value}
            size="sm"
          />
        )
      }}
    />
  )
}
